import { on } from 'delegated-events'

const SELECTORS = Selectors({
  toggleBlock: 'toggle-block',
  toggleBlockToggle: 'toggle-block__toggle',
  toggleBlockClose: 'toggle-block__close',
  toggleBlockBody: 'toggle-block__body'
})

const $toggleBlocks = document.querySelectorAll(SELECTORS.asClass('toggleBlock'))

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    on('click', SELECTORS.asClass('toggleBlockToggle'), fn.toggle)
    on('keydown', SELECTORS.asClass('toggleBlockToggle'), fn.toggle)
    on('click', SELECTORS.asClass('toggleBlockClose'), fn.close)
  },

  toggle: (e) => {
    const $block = e.target.closest(SELECTORS.asClass('toggleBlock'))
    const $button = e.target

    if ($block) {
      const expanded = $button.getAttribute('aria-expanded') === 'true'

      $button.setAttribute('aria-expanded', expanded ? 'false' : 'true')
      $block.classList.toggle('is-active')

      $button.textContent = expanded ?
        $button.dataset.closedLabel :
        $button.dataset.openedLabel

      $($block.querySelector(SELECTORS.asClass('toggleBlockBody'))).slideToggle(() => {
        // Resize any hidden sliders
        window.dispatchEvent(new Event('resize'))

        const resizeEvent = window.document.createEvent('UIEvents')
        resizeEvent.initUIEvent('resize', true, false, window, 0)
        window.dispatchEvent(resizeEvent)
      })
    }
  },

  close: (e) => {
    const $block = e.target.closest(SELECTORS.asClass('toggleBlock'))
    const $button = $block.querySelector(SELECTORS.asClass('toggleBlockToggle'))

    if ($block) {
      const expanded = $button.getAttribute('aria-expanded') === 'true'

      $button.setAttribute('aria-expanded', expanded ? 'false' : 'true')
      $block.classList.toggle('is-active')

      $button.textContent = expanded ?
        $button.dataset.closedLabel :
        $button.dataset.openedLabel

      $($block.querySelector(SELECTORS.asClass('toggleBlockBody'))).slideToggle()
    }
  }
}

export default {
  can: () => $toggleBlocks.length,
  run: fn.init
}
